import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {BoostedDapp} from '@/model/resource/BoostedDapp'
import {DappCollection} from '@/model/collection/DappCollection'

@HttpExclude()
export class BoostedDappCollection extends ExpansibleCollection<BoostedDapp> {
  resource?: IBoostedDappCollectionResourcesHolder
  @RequestExpose() minOrder: number | null = null
  @RequestExpose() maxOrder: number | null = null

  constructor() {
    super(BoostedDapp)
  }

  queryAsPage() {
    return this.listBoostedDapp()
  }

  async listBoostedDapp() {
    return await Request.get(`/client/boosted-dapp`, {
      params: this.params,
    })
      .name('listBoostedDapp')
      .as(this)
      .getResponse()
  }

  async listExportBoostedDapp() {
    return await Request.get(`/client/boosted-dapp/export`, {
      params: this.params,
    })
      .name('listExportBoostedDapp')
      .as(this)
      .getResponse()
  }
}

export interface IBoostedDappCollectionResourcesHolder {
  collectionDapp: DappCollection
}
